"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractEvent = void 0;
class AbstractEvent {
    constructor(config) {
        this.config = config;
        if (!this.config) {
            throw new TypeError('AbstractEvent config is undefined.');
        }
    }
    setGlobals(globals) {
        if (globals.currency && !this.config.currency) {
            this.config.currency = globals.currency;
        }
        if (globals.language && !this.config.language) {
            this.config.language = globals.language;
        }
    }
}
exports.AbstractEvent = AbstractEvent;
//# sourceMappingURL=abstract.event.js.map